interface Props {
  style?: any;
}

export default function Divider(props: Props) {
  return <div style={{ ...props.style, ...divider }}></div>;
}

const divider = {
  height: 1,
  backgroundColor: "#E8E8E8",
  width: "100%",
};
